module.exports = __webpack_public_path__ + "media/images/footer-f270d7fbc0170ca56cc62144a177e329.png";